import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSubMenu } from '../../../../../empreenderUI/SubMenuContext';
import ScrollArea from '../../../../../empreenderUI/components/ScrollArea';
import Heading from '../../../../../empreenderUI/ui/Heading/Heading';
import SaveControls from '../../../../../empreenderUI/components/Slots/Buttons';
import Input from '../../../../../empreenderUI/ui/Input';
import { Textarea } from '../../../../../empreenderUI/ui/Textarea';
import ColorSwatchPicker from '../../../components/ColorSwatchPicker';
import { translations } from '../../../../../utils/language';

const CheckoutContent = () => {
  const { toggle } = useSubMenu();
  const history = useHistory();
  const dispatch = useDispatch();
  const controlConfig = useSelector((state) => state.reducerControlConfig);
  const config = useSelector((state) => state.reducerTemplate);
  const language = useSelector((state) => state.reducerLanguage);
  const [screen] = useState(window.screen.height);

  const selectedColor = controlConfig.checkout_color || 'gray';

  const getDefaultConfig = () => {
    const themaDefault = {
      id: config.data[0].id,
      checkout_message_header: translations['thema-default-header'][language.data],
      checkout_message_title: translations['thema-default-title'][language.data],
      checkout_message: translations['thema-default-message'][language.data],
      checkout_button: translations['thema-default-button'][language.data],
      checkout_button_link: translations['thema-default-link'][language.data],
      available_time: 30,
    };
    dispatch({ type: 'SAGA_UPDATE_TEMPLATE', payload: themaDefault });
  };

  useEffect(() => {
    if (!config?.data?.[0]) return;
    const saved =
      config.data[0].color_checkout_background_header == controlConfig.color_checkout_background_header &&
      config.data[0].color_checkout_text_header == controlConfig.color_checkout_text_header &&
      config.data[0].color_checkout_background == controlConfig.color_checkout_background &&
      config.data[0].color_checkout_text_title == controlConfig.color_checkout_text_title &&
      config.data[0].color_checkout_background_product == controlConfig.color_checkout_background_product &&
      config.data[0].color_checkout_text_product == controlConfig.color_checkout_text_product &&
      config.data[0].color_button_checkout == controlConfig.color_button_checkout &&
      config.data[0].color_message_button_checkout == controlConfig.color_message_button_checkout &&
      config.data[0].checkout_message_header == controlConfig.checkout_message_header &&
      config.data[0].checkout_message_title == controlConfig.checkout_message_title &&
      config.data[0].checkout_message == controlConfig.checkout_message &&
      config.data[0].checkout_button == controlConfig.checkout_button &&
      config.data[0].checkout_button_link == controlConfig.checkout_button_link &&
      config.data[0].checkout_color == controlConfig.checkout_color;

    dispatch({ type: 'CONFIG_CONTROL_SAVE_CHECKOUT_SET', payload: !!saved });
  }, [controlConfig, config, dispatch]);

  return (
    <ScrollArea>
      <Heading
        header={translations['thema-checkout']?.[language.data] || 'Checkout'}
        text={translations['Personalize sua tela de checkout']?.[language.data]}
        onClick={() => {
          history.push('/personalizar');
          toggle('personalizar');
        }}
      />

      <div className='flex flex-col gap-4 px-6 py-4'>
        <div className='flex flex-col gap-1.5'>
          <label className='text-xs font-medium text-gray-700'>{translations['thema-cor']?.[language.data]}</label>
          <ColorSwatchPicker
            value={selectedColor}
            language={language.data}
            ariaLabel={translations['thema-cor']?.[language.data]}
            onChange={(color) =>
              dispatch({
                type: 'CONFIG_CONTROL_SET',
                payload: { checkout_color: color },
              })
            }
          />
        </div>

        <div className='flex flex-col gap-1.5 relative'>
          <label className='text-xs font-medium text-gray-700'>{translations['thema-titulo']?.[language.data]}:</label>
          <Textarea
            value={controlConfig.checkout_message_title || ''}
            minRows={screen < 800 ? 1 : 3}
            maxRows={screen < 800 ? 2 : 4}
            maxLength={255}
            placeholder={translations['thema-titulo-pagina-placeholder']?.[language.data]}
            onChange={(e) =>
              dispatch({
                type: 'CONFIG_CONTROL_SET',
                payload: { checkout_message_title: e.target.value },
              })
            }
          />
          <span className='absolute bottom-2 right-2 text-[10px] text-gray-400'>{255 - (controlConfig.checkout_message_title?.length || 0)}</span>
        </div>

        <div className='flex flex-col gap-1.5 relative'>
          <label className='text-xs font-medium text-gray-700'>{translations['thema-subtitulo']?.[language.data]}:</label>
          <Textarea
            value={controlConfig.checkout_message || ''}
            minRows={screen < 800 ? 1 : 3}
            maxRows={screen < 800 ? 2 : 4}
            maxLength={255}
            placeholder={translations['thema-subtitulo-pagina-placeholder']?.[language.data]}
            onChange={(e) =>
              dispatch({
                type: 'CONFIG_CONTROL_SET',
                payload: { checkout_message: e.target.value },
              })
            }
          />
          <span className='absolute bottom-2 right-2 text-[10px] text-gray-400'>{255 - (controlConfig.checkout_message?.length || 0)}</span>
        </div>

        <div className='flex flex-col gap-3'>
          <label className='text-xs font-medium text-gray-700'>{translations['thema-botoes']?.[language.data]}:</label>
          <div className='flex flex-col gap-1.5'>
            <label className='text-xs text-gray-500'>{translations['thema-download-acao']?.[language.data]}</label>
            <Input
              type='text'
              className='!border !border-solid !border-gray-200 !bg-white'
              value={controlConfig.checkout_button || ''}
              placeholder={translations['thema-baixar']?.[language.data]}
              onChange={(e) =>
                dispatch({
                  type: 'CONFIG_CONTROL_SET',
                  payload: { checkout_button: e.target.value },
                })
              }
            />
          </div>
          <div className='flex flex-col gap-1.5'>
            <label className='text-xs text-gray-500'>{translations['thema-link']?.[language.data]}</label>
            <Input
              type='text'
              className='!border !border-solid !border-gray-200 !bg-white'
              value={controlConfig.checkout_button_link || ''}
              placeholder={translations['thema-baixar']?.[language.data]}
              onChange={(e) =>
                dispatch({
                  type: 'CONFIG_CONTROL_SET',
                  payload: { checkout_button_link: e.target.value },
                })
              }
            />
          </div>
        </div>
      </div>

      <SaveControls
        onCancel={getDefaultConfig}
        cancelText={translations['thema-restaurar']?.[language.data]}
      />
    </ScrollArea>
  );
};

export default CheckoutContent;
